import React from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

interface Props<E> {
  title: string;
  field: keyof E;
  currentOrder: "asc" | "desc";
  currentField: keyof E;
  changeOrderBy: (newField: keyof E) => void;
  renderBullet?: boolean;
  dataCy?: string;
}

export function OrderByButton<E>(props: Props<E>) {
  function renderOrderIcon(): React.JSX.Element {
    if (props.currentField === props.field) {
      if (props.currentOrder === "asc") {
        return <FontAwesomeIcon icon={faAngleUp} />;
      } else {
        return <FontAwesomeIcon icon={faAngleDown} />;
      }
    } else {
      return props.renderBullet ? <>&bull;</> : <></>;
    }
  }

  return (
    <Button
      color="link"
      style={{ padding: "0", textDecoration: "none" }}
      onClick={() => props.changeOrderBy(props.field)}
      data-cy={props.dataCy}
    >
      {renderOrderIcon()} {props.title}
    </Button>
  );
}
